import React from 'react';
import PurchaseOrder from './purchaseorder'; // Adjust the path as per the folder structure

export default function Index() {
  return (
    <div>
      <PurchaseOrder />
    </div>
  );
}
